import Button from './button';

export default (props) => {
    const { children, className } = props;

    return <Button { ...props } className={`button__small button__fit ${className}`} arrow={false}>{ children }</Button>
}